export { default as afterConferenceConfig } from './afterConference'
export { default as conferenceConfig } from './conference'
export { default as countdownConfig } from './countdown'
export { default as registrationConfig } from './registration'

export const EXPERIENCE = {
  ANNOUNCE: 'announce',
  REGISTRATION: 'registration',
  COUNTDOWN: 'countdown',
  CONFERENCE: 'conference',
  AFTER_CONFERENCE: 'afterConference',
}
